module.exports = __webpack_public_path__ + "img/heart.66182100.svg";